module.exports = __webpack_public_path__ + "img/12-2.77202863.jpg";